import clsx from 'clsx';
import { PropsWithChildren, ReactNode } from 'react';

import { ModalType } from './types';
import { useModalContext } from './Modal';
import styles from './ModalHeader.module.css';

interface Props {
  title: ReactNode;
  modalType?: ModalType;
  className?: string;
}

export function ModalHeader({
  title,
  modalType,
  className,
  children,
}: PropsWithChildren<Props>) {
  useModalContext();

  return (
    <div className={clsx('p-0 pb-4', className)}>
      {modalType && (
        <div
          className={clsx({
            [styles.backgroundError]: modalType === ModalType.Destructive,
            [styles.backgroundWarning]: modalType === ModalType.Warn,
          })}
        />
      )}
      {typeof title === 'string' ? (
        <h5 className="m-0 font-bold">{title}</h5>
      ) : (
        title
      )}
      {children}
    </div>
  );
}
